import Page from '../Pages/Page'
import { storage } from '../../firebase/firebase.config'
import { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { CKEditor } from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import Spinner from '../Spinner/Spinner'
import { getDownloadURL, uploadBytesResumable, ref } from 'firebase/storage'

const AddNewPost = () => {
	const [loading, setLoading] = useState(false)
	const [editorData, setEditorData] = useState()
	const [image, setImage] = useState(null)
	const history = useHistory()

	// firebase storage
	const uploadHandler = (e) => {
		e.preventDefault()
		const file = e.target.files[0]
		upload(file)
	}

	const upload = (file) => {
		if (!file) return
		const storageRef = ref(storage, `/file${file.name}`)
		const uploadTask = uploadBytesResumable(storageRef, file)

		uploadTask.on(
			'state_changed',
			(snapshot) => {
				const prog =
					Math.round(
						snapshot.bytesTransferred / snapshot.totalBytes
					) * 100
			},
			(err) => console.log(err),
			() => {
				getDownloadURL(uploadTask.snapshot.ref).then((url) => [
					console.log(url),
					setImage(url),
				])
			}
		)
	}

	const thumbRef = useRef()
	const titleRef = useRef()
	const descRef = useRef()

	const token = JSON.parse(localStorage.getItem('user'))

	const handleEditor = (e, editor) => {
		setEditorData(editor.getData())
	}

	const handleAddPost = (e) => {
		e.preventDefault()

		const newPost = {
			title: titleRef.current.value,
			description: editorData,
			thumbnail: image,
		}

		setLoading(true)
		fetch('https://cp-node-api.herokuapp.com/api/posts', {
			method: 'POST',
			headers: {
				token: `Bearer ${token.accessToken}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(newPost),
		})
			.then((res) => res.json())
			.then((data) => {
				if (data._id) {
					history.push('/posts')
					setLoading(false)
				}
			})

		e.target.reset()
	}

	return (
		<Page>
			<section className='add-new'>
				<h4 className='mb-4'>Add New Post {loading && <Spinner />}</h4>
				{image && (
					<img className='w-50 mb-3 rounded' src={image} alt='' />
				)}
				<form className='w-50' onSubmit={handleAddPost}>
					<div className='form-group mb-3'>
						<input
							onChange={uploadHandler}
							type='file'
							className='form-control'
						/>
					</div>
					<div className='form-group mb-3'>
						<input
							ref={titleRef}
							type='text'
							className='form-control'
							placeholder='Title'
							required
						/>
					</div>
					<div className='form-group mb-3'>
						<CKEditor
							onChange={handleEditor}
							editor={ClassicEditor}
						/>
					</div>
					<button className='btn btn-primary'>Publish</button>
				</form>
			</section>
		</Page>
	)
}

export default AddNewPost
